import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL;
export const WSS_URL = process.env.REACT_APP_WSS_URL;

export const API = axios.create({
    timeout: 10000,
    baseURL: API_URL,
});